import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { createThunkHttp } from '../../services/helpers/thunk';

import {
  httpGetListings,
  httpGetListing,
} from '../../services/http';

const defaultFilters = {
  bedrooms: '',
  bathrooms: '',
  size_min: '',
  size_max: '',
  rent_min: '',
  rent_max: '',
};

export const listingsAdapter = createEntityAdapter({
  selectId: (item) => item.listing_id,
});

export const listingsSelector = listingsAdapter.getSelectors((state) => state.listings);
export const selectListings = (state) => listingsSelector.selectAll(state);
export const selectListingById = (state, id) => listingsSelector.selectById(state, id);
export const selectListingsLoading = (state) => state.listings.isLoading;
export const selectListingsNext = (state) => state.listings.next;
export const selectListingsPage = (state) => state.listings.page;
export const selectListingsSearch = (state) => state.listings.search;
export const selectListingsFilters = (state) => state.listings.filters;
export const selectListingsIsFiltersDefault = (state) => JSON.stringify(state.listings.filters)
  === JSON.stringify(defaultFilters);

// Thunks
export const getListings = createThunkHttp(
  'listings/getListings',
  httpGetListings,
);

// Thunks
export const getListing = createThunkHttp(
  'listings/getListing',
  httpGetListing,
);

export const listingsSlice = createSlice({
  name: 'listings',
  initialState: listingsAdapter.getInitialState({
    isLoading: false,
    page: 1,
    search: '',
    next: null,
    filters: defaultFilters,
    defaultFilters,
  }),
  reducers: {
    setNextPage: (state) => {
      if (state.next) {
        state.page += 1;
        state.isLoading = true;
      }
    },
    setSearch: (state, action) => {
      state.page = 1;
      state.search = action.payload;
      state.isLoading = true;
    },
    setFilters: (state, action) => {
      state.page = 1;
      state.filters = action.payload;
    },
    setFilter: (state, action) => {
      state.page = 1;
      state.filters[action.payload.key] = action.payload.value;
    },
    resetListParams: (state) => {
      state.page = 1;
      state.search = '';
      state.filters = defaultFilters;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListings.fulfilled, (state, action) => {
        if (action.payload) {
          if (state.page < 2) {
            listingsAdapter.setAll(state, action.payload.results);
          } else {
            listingsAdapter.addMany(state, action.payload.results);
          }
          state.next = action.payload.next;
        }
        state.isLoading = false;
      })
      .addCase(getListings.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListing.fulfilled, (state, action) => {
        listingsAdapter.upsertOne(state, action.payload);
        state.isLoading = false;
      })
      .addCase(getListing.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {
  setNextPage, setSearch, setFilters, setFilter, resetListParams,
} = listingsSlice.actions;

export default listingsSlice.reducer;
